import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  AddUserPermissionRequest,
  AddUserPermissionResponse,
  GetAPIPermissionsRequest,
  GetAPIPermissionsResponse,
  GetUserPermissionsRequest,
  UpdateUserPermissionRequest,
} from "../models/userPermission.model";
import { ApiBaseUrl, UserPermission } from "../config/config";

export const AddUserPermissions = async (
  data: AddUserPermissionRequest
): Promise<AddUserPermissionResponse[]> => {
  return await Axios.post<ApiResultModel<AddUserPermissionResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + UserPermission + "/AddUserPermissions",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetUserPermissions = async (
  data: GetUserPermissionsRequest
): Promise<AddUserPermissionResponse[]> => {
  return await Axios.post<ApiResultModel<AddUserPermissionResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + UserPermission + "/GetUserPermissions",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const UpdateUserPermission = async (
  data: UpdateUserPermissionRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + UserPermission + "/UpdateUserPermission",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteUserPermission = async (data: {
  userPermissionId: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + UserPermission + "/DeleteUserPermission",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetAPIPermissions = async (
  data: GetAPIPermissionsRequest
): Promise<GetAPIPermissionsResponse[]> => {
  return await Axios.post<ApiResultModel<GetAPIPermissionsResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + UserPermission + "/GetPermissions",
    data
  ).then((result) => {
    return result.data.data;
  });
};
